import { render, staticRenderFns } from "./GeneralInformationPanel.vue?vue&type=template&id=2668d472&scoped=true&"
import script from "./GeneralInformationPanel.vue?vue&type=script&lang=js&"
export * from "./GeneralInformationPanel.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInformationPanel.vue?vue&type=style&index=0&id=2668d472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668d472",
  null
  
)

export default component.exports